<template>
  <div>
    <b-navbar toggleable="lg" type="light" style="background-color: #ffffff!important; height: 90px; border-bottom: 1px solid lightgrey;">
      <b-navbar-brand href="#">
        <img :src="getHeaderImageUrl()" height="70px" class="d-inline-block align-top" alt="logo"/>
      </b-navbar-brand>

      <b-navbar-toggle target="nav_collapse"/>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav class="ml-auto">
          <LocaleSwitcher></LocaleSwitcher>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import { apiUrl } from '../_config'
import LocaleSwitcher from '../components/LocaleSwitcher'

export default {
  components: {
    LocaleSwitcher
  },
  methods: {
    getHeaderImageUrl: function () {
      if (this.$cookies.get('client_logo') && this.$cookies.get('client_logo') !== null && this.$cookies.get('client_logo').trim() !== '') {
        return apiUrl() + 'media/logo/' + this.$cookies.get('client_logo')
      }
      return apiUrl() + 'media/logo/default'
    }
  }
}
</script>
<style>

</style>
